import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const CalendarIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="15.207" height="15.207" viewBox="0 0 15.207 15.207">
      <g id="Icon_feather-calendar" data-name="Icon feather-calendar" transform="translate(-3.5 -2.5)">
        <g
          id="Path_42320"
          data-name="Path 42320"
          transform="translate(0 -1)"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path
            d="M6.1,6H17.3a1.578,1.578,0,0,1,1.6,1.556V18.444A1.578,1.578,0,0,1,17.3,20H6.1a1.578,1.578,0,0,1-1.6-1.556V7.556A1.578,1.578,0,0,1,6.1,6Z"
            stroke="none"
          />
          <path
            d="M 6.100000381469727 6 C 5.216339111328125 6 4.5 6.696449279785156 4.5 7.555559158325195 L 4.5 18.44443893432617 C 4.5 19.30355072021484 5.216339111328125 20 6.100000381469727 20 L 17.29999923706055 20 C 18.18365097045898 20 18.89999961853027 19.30355072021484 18.89999961853027 18.44443893432617 L 18.89999961853027 7.555559158325195 C 18.89999961853027 6.696449279785156 18.18365097045898 6 17.29999923706055 6 L 6.100000381469727 6 M 6.100000381469727 5 L 17.29999923706055 5 C 18.73363876342773 5 19.89999961853027 6.146419525146484 19.89999961853027 7.555559158325195 L 19.89999961853027 18.44443893432617 C 19.89999961853027 19.85358047485352 18.73363876342773 21 17.29999923706055 21 L 6.100000381469727 21 C 4.666358947753906 21 3.5 19.85358047485352 3.5 18.44443893432617 L 3.5 7.555559158325195 C 3.5 6.146419525146484 4.666358947753906 5 6.100000381469727 5 Z"
            stroke="none"
            fill="#9aa4b3"
          />
        </g>
        <path
          id="Path_42321"
          data-name="Path 42321"
          d="M24,3V7"
          transform="translate(-9.1 0)"
          fill="none"
          stroke="#9aa4b3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_42322"
          data-name="Path 42322"
          d="M12,3V7"
          transform="translate(-3.5 0)"
          fill="none"
          stroke="#9aa4b3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
        <path
          id="Path_42323"
          data-name="Path 42323"
          d="M4.5,15H18.9"
          transform="translate(0 -5.6)"
          fill="none"
          stroke="#9aa4b3"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        />
      </g>
    </SvgIcon>
  );
};
